import { useNavigate } from 'react-router-dom';
import { cn } from './utils';

interface BackButtonProps {
  to: string;
  className?: string;
  label?: string;
}

export function BackButton({ to, className, label = 'Back' }: BackButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to);
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'flex cursor-pointer items-center gap-2 border-none bg-transparent p-0',
        'transition-opacity hover:opacity-70',
        className,
      )}
      aria-label={`Go back to ${label}`}
      type="button">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none">
        <path
          d="M17 7H1M1 7L7 13M1 7L7 1"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="text-sh-12-18 font-bold text-people-teal-600">{label}</span>
    </button>
  );
}
